import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { handlePostRequest } from "../../services/PostTemplate";
import * as Yup from "yup";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import { useHistory } from "react-router-dom";

const SearchAccountForStatement = ({ api, handleReturnData, title }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");
    const [userNotFound, setUserNotFound] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [otpLimitText, setOtpLimitText] = useState("");

    let history = useHistory();

    useEffect(() => {
        // Check localStorage on component mount to see if button should be disabled
        const clickData = JSON.parse(localStorage.getItem("acStatmentSearchOtpLimit")) || {};
        const { clicks, timestamp } = clickData;
        const now = new Date().getTime();

        if (clicks >= 4 && timestamp && now - timestamp < 120000) {
            setIsButtonDisabled(true);
            const remainingTime = 120000 - (now - timestamp);
            setTimeout(() => resetClicks(), remainingTime);
        } else {
            resetClicks();
        }
    }, []);

    const resetClicks = () => {
        setIsButtonDisabled(false);
        setOtpLimitText("")
        localStorage.removeItem("acStatmentSearchOtpLimit");
    };

    const handleButtonClick = () => {
        const clickData = JSON.parse(localStorage.getItem("acStatmentSearchOtpLimit")) || { clicks: 0, timestamp: 0 };
        let { clicks } = clickData;
        clicks += 1;

        if (clicks > 3) {
            setIsButtonDisabled(true);
            localStorage.setItem("acStatmentSearchOtpLimit", JSON.stringify({ clicks, timestamp: new Date().getTime() }));
            setOtpLimitText("Too many wrong attemps! Please try after 2mins.")
            setTimeout(() => resetClicks(), 120000); // 2-minute timer
        } else {
            localStorage.setItem("acStatmentSearchOtpLimit", JSON.stringify({ clicks, timestamp: clickData.timestamp }));
        }
    };

    const validationSchema = Yup.object().shape({
        mobileNo: Yup.string()
            .required("This field is required.")
            .matches(/^\d{11}$/, "Mobile number should be exactly 11 digits and should not contain any spaces."),
        fromDate: Yup.date()
            .required("This field is required.")
            .nullable()
            .max(Yup.ref("toDate"), "From Date cannot be greater than To Date.")
            .test("max-date-range", "Date range should be within 365 days.", function (value) {
                const toDate = this.resolve(Yup.ref("toDate"));
                const fromDate = value;

                if (fromDate && toDate) {
                    const dateDifference = toDate.getTime() - fromDate.getTime();
                    const daysDifference = dateDifference / (1000 * 60 * 60 * 24);

                    return daysDifference <= 365;
                }

                return true; // Validation passes if either date is not set
            }),
        toDate: Yup.date().required("This field is required.").nullable().min(Yup.ref("fromDate"), "To Date cannot be lesser than From Date."),
    });

    // function convertDateFormat(dateStr) {
    //     const [year, month, day] = dateStr.split("-");
    //     return `${day}/${month}/${year}`;
    // }

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            mobileNo: "",
            fromDate: "",
            toDate: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                // data.fromDate = convertDateFormat(data.fromDate);
                // data.toDate = convertDateFormat(data.toDate);
                const res = await handlePostRequest(data, api);
                handleReturnData(res, data);
                setloading(false);
                setloadingIcon("pi pi-save");
            } catch (error) {
                console.log('error', error)
                if (error.response.data.messages === "User not found")
                    setUserNotFound(true)
                handleReturnData(userNotFound);
            }
            finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const props = { onChange: formik.handleChange, values: formik.values, isFormFieldValid: isFormFieldValid, getFormErrorMessage: getFormErrorMessage };

    return (

        <div>

            <div className="page_header">

                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                    <div className="d_align">

                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />

                        <h3 className="mod_heading">{title}</h3>

                    </div>

                </div>

            </div>

            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field input_cp">
                                <ZbizInput required type="date" label="From Date" keyName="fromDate" {...props} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field input_cp">
                                <ZbizInput required type="date" label="To Date" keyName="toDate" {...props} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field input_cp">
                                <ZbizInput required placeholder="Enter Mobile Number" label="Mobile" keyName="mobileNo" {...props} />
                            </div>
                        </div>
                    </div>

                    <div className="GenerateDown__Btn p-mt-4">
                        <Button type="submit" disabled={isButtonDisabled || loading} icon={loadingIcon || ""} iconPos="right" label={"Search"} className="Btn__Transparent" onClick={handleButtonClick} />
                    </div>
                    <small className="p-mt-4" style={{ display: "block", color: "red" }}>
                        {otpLimitText && otpLimitText}
                    </small>
                </form>
            </div>

        </div>
    );
};

export default SearchAccountForStatement;
